import * as yup from 'yup';

export const solicitudUpdFotosSchema = yup.object({
  comentario_solicita_upd_fotos: yup
    .string()
    .required('El comentario es requerido'),
});
